import React, { useEffect, useState } from 'react';
import { Avatar, Box, Button, Chip, IconButton, Typography } from '@mui/material';
import { HeadsetMic } from '@mui/icons-material';
import { Link } from 'react-router-dom';
import { formatDateTime } from './Format';
import api from "../api";
import WebCall from '../pages/WebCall';
import { ButtonSx, SecondaryChipSx } from '../styles/GlobalStyles';
import { Icon } from "@iconify/react";
const AssistantCard = ({ name, category, Type, description, lastUpdated, fileUrl, onVolumeClick, buttonAction, assistant }) => {

  const [isModalOpen, setIsModalOpen] = useState(false);  // State to manage modal
  const [assistantConfig, setAssistantConfig] = useState();
  const [token, setToken] = useState("");
  const [credit, setCredit] = useState(0);

  const handleWebCall = async () => {
    const response = await api.post("/assistants/initiate-web-call", {
      assistantId: assistant._id,
      organizationId: localStorage.getItem("Organization")
    }, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      }
    })

    setAssistantConfig(response.data.data)
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);  // Close the modal when "End Call" is clicked
  };

  const getToken = () => {
    const t = JSON.parse(localStorage.getItem('token')).token;
    setToken(t);
  };

  useEffect(() => {
    getToken();
    const credit_local = localStorage.getItem('Credit');
    setCredit(credit_local)
  }, [token]);
  
  return (
    <>
      <Box
        sx={{
          borderRadius: '1.5rem',
          border: '1px solid #E5E7EB',
          backgroundColor: '#fff',
          p: '1.5rem',
          display: 'flex',
          flexDirection: 'column',
          gap: '1rem',
          height: '100%',
          transition: 'transform 0.3s ease, box-shadow 0.3s ease',
          '&:hover': {
            transform: 'scale(1.01)',
            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.06)',

          },
        }}
      >
        {/* Header: Avatar + Name/Description */}
        <Box sx={{ display: "flex", flexDirection: "column", gap: "0.5rem", width: "100%" }}>
          <Box sx={{ display: "flex", alignItems: "center", gap: "1rem", width: "100%" }}>
          <Avatar
              alt={name}
              src={fileUrl}
              sx={{
                width: 56,
                height: 56,
                backgroundColor: '#ededed',
                fontWeight: 600,
                fontSize: '1rem',
                color: '#02042D',
              }}
            >
              {name?.[0]?.toUpperCase()}
            </Avatar>

            <Box sx={{ flexGrow: 1, display: "flex", flexDirection: "column", gap: "0.3rem", overflow: "hidden" }}>
              <Typography
                variant="h6"
                noWrap
                sx={{
                  color: "#343434",
                  fontSize: "1rem",
                  fontWeight: 600,
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                  maxWidth: "100%",
                }}
              >
                {name}
              </Typography>
              <Typography
                variant="body2"
                noWrap
                sx={{
                  color: "#555",
                  fontSize: "0.875rem",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                  maxWidth: "100%",
                }}
              >
                {description}
              </Typography>
            </Box>
          </Box>

          {/* Chips */}
          <Box sx={{ display: "flex", gap: "0.5rem", mt: "0.5rem" }}>
            <Chip
              icon={
                Type === "inbound" ? (
                  <Icon icon="solar:incoming-call-bold" width="12" height="12" />
                ) : (
                  <Icon icon="solar:outgoing-call-bold" width="12" height="12" />
                )
              }
              label={Type.charAt(0).toUpperCase() + Type.slice(1)}
              sx={SecondaryChipSx}
            />
            <Chip label={category} sx={SecondaryChipSx} />
          </Box>
        </Box>

        {/* Last Updated */}
        <Typography variant="caption" sx={{ color: "#6B7280", fontSize: "0.75rem" }}>
          Last Updated: {formatDateTime(lastUpdated)}
        </Typography>

        {/* Footer: Action Buttons */}
        <Box sx={{ display: "flex", gap: "0.25rem" }}>
          <Link to={buttonAction.url} style={{ flex: 1 }}>
            <Button variant="contained" sx={ButtonSx({ width: "100%" })} fullWidth>
              {buttonAction.label}
            </Button>
          </Link>
          <IconButton
            sx={{ color: "#02042D", ml: 0.5 }}
            onClick={handleWebCall}
            disabled={credit === 0}
          >
            <HeadsetMic />
          </IconButton>
        </Box>
      </Box>

      {/* Modal for Web Call */}
      {isModalOpen &&
        <WebCall
          open={isModalOpen}
          onClose={handleCloseModal}
          avatar={assistant.Logo.fileUrl}
          name={assistant.Name}
          wsUrl={`${process.env.REACT_APP_VOICE_URL}`}
          callConfig={assistantConfig}
        />
      }
    </>
  );
};

export default AssistantCard;
